// src/components/Message.tsx
import React from 'react';
import { MessageDto } from "../models/MessageDto";

interface MessageProps {
  message: MessageDto;
}

const Message: React.FC<MessageProps> = ({ message }) => {
  return (
    <div className={ message.isUser ? "message-user" : "message-kbot"} style={{ textAlign: message.isUser ? "right" : "left", margin: "8px" }}>
      <div key={message.id}
        style={{
          color: message.isUser ? "#000000" : "#313131" ,
          backgroundColor: message.isUser ? "#eaeaea" : "#E7EDF3" ,
          padding: "10px 15px",
          borderRadius: "5px",
          marginLeft:  message.isUser ? 0 : "2rem"
        }}
      >
        {message.content.split("\n").map((text, index) => (
          <>
            {text}
            <br />
          </>
        ))}
      </div>
    </div>
  );
};

export default Message;
